export default {
    baseStyle: {
        container: {
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            transition: 'top 0.3s ease'
        },
        containerFixed: {
            position: 'fixed',
            right: {base: '0', lg: '24px'},
            left: {base: '0', lg: 'auto'},
            width: {base: '100%', lg: '400px'}
        },
        containerInline: {
            position: 'absolute',
            top: '0',
            right: '0',
            left: '0',
            width: '100%'
        },
        toast: {
            textStyle: 'bodyXsRegular',
            bg: 'webTheme.backgroundReverse',
            color: 'webTypo.textOnColor',
            p: 3,
            display: 'flex',
            alignItems: 'center',
            minH: {base: '44px'}
        },
        icon: {
            mr: 2,
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            boxSize: 5
        },
        message: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textOnColor',
            flex: 1,
            pr: 2
        },
        closeButton: {
            ml: 5,
            minW: 'auto',
            h: 'auto',
            color: 'white',
            _hover: {bg: 'transparent'},
            _active: {bg: 'transparent'}
        },
        closeIcon: {
            boxSize: '20px'
        },
        action: {
            textStyle: 'bodyXsLink',
            height: 'auto',
            color: 'webTypo.textOnColor'
        }
    }
}
